// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash/fp';

// Components
import PageContent from './PageContent';

import ModalErrorBoundary from './errorBoundary/ModalErrorBoundary';
import ModalCloseButton from './ModalCloseButton';
import ModalBackButton from './ModalBackButton';

// Styles
import './Modal.scss';

class Modal extends React.Component {
    componentWillMount() {
        const { blur, noTransition } = this.props;

        // If we don't want to transition the blur / grayscale
        noTransition ? document.body.classList.add('no-transition') : document.body.classList.remove('no-transition');

        if (blur) {
            this.blurred = true;
            document.body.classList.add('blur');
        }
    }

    componentDidMount() {
        const { bodyClass = 'modal' } = this.props;

        // On a page change, componentWillUnmount of previous component might be called after componentWillMount
        // of the next component, so it is important to do this in componentDidMount to make sure bodyClass is
        // added and removed properly
        !isEmpty(bodyClass) && document.body.classList.add(bodyClass);
    }

    componentWillUnmount() {
        const { bodyClass = 'modal' } = this.props;

        !isEmpty(bodyClass) && document.body.classList.remove(bodyClass);

        if (this.blurred) document.body.classList.remove('blur');
    }

    render() {
        const { children, className, onClick, styled } = this.props;

        return (
            <div className="modal-container" onClick={onClick}>
                <div className={classNames('Modal', className)}>
                    <ModalErrorBoundary {...this.props}>
                        <ModalBackButton {...this.props} />
                        <ModalCloseButton {...this.props} />
                        <PageContent className="modal-content" styled={styled}>
                            {children}
                        </PageContent>
                    </ModalErrorBoundary>
                </div>
            </div>
        );
    }
}

Modal.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    close: PropTypes.func,

    styled: PropTypes.bool,
    blur: PropTypes.bool,
    noTransition: PropTypes.bool,
    bodyClass: PropTypes.string,
};

export default Modal;
